import { Component, Input } from '@angular/core';
import { ReportConfigWithVisibility } from '@app/workflow/components/report-card/report-filter.service';
import { SessionItemData } from '@app/workflow/services/session-item-data';
import { IParticipant } from '@interfaces/interfaces';

@Component({
	selector: 'workflow-report-card',
	templateUrl: './report-card.component.html',
	styleUrls: ['./report-card.component.scss'],
})
export class ReportCardComponent {

	@Input() participant: IParticipant;
	@Input() reportData: SessionItemData;

	isResetModalVisible: boolean;
	isPopoverVisible: boolean;
	isCardHidden: boolean;

	@Input() usedReportConfigs: ReportConfigWithVisibility[];

	constructor() { }

	showResetModal(): void {
		this.isResetModalVisible = true;
		this.isPopoverVisible = false;
	}

	handleResetCancel(): void {
		this.isResetModalVisible = false;
	}
}
